module.exports = __webpack_public_path__ + "static/famis-f17c469ae3932a3d3b0012854c64b38f.jpg";